import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { LoadingScreen } from '../../components/shared/LoadingScreen/LoadingScreen';
import { selectDirectSignupStep } from './directSignupSlice';
import { Header } from '../../components/Header/Header';
import { DirectSignupEmail } from './DirectSignupEmail';
import { DirectSignupUsername } from './DirectSignupUsername';
import { DirectSignupPassword } from './DirectSignupPassword';
import { DirectSignupHmi } from './DirectSignupHmi';
import { DirectSignupProcess } from './DirectSignupProcess';

type Props = {
  path?: string;
};
const DirectSignupSteps: React.FC<Props> = () => {
  const step = useSelector(selectDirectSignupStep);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  switch (step) {
    case 0:
      return <DirectSignupEmail />;
    case 1:
      return <DirectSignupUsername />;
    case 2:
      return <DirectSignupPassword />;
    case 3:
      return <DirectSignupHmi />;
    default:
      return <LoadingScreen messageId={'hatters.signup.errorOccurred'} />;
  }
};

export const DirectSignup: React.FC<Props> = () => {
  return (
    <>
      <Header loginBtn={true} signupBtn={false} />
      <DirectSignupProcess>
        <DirectSignupSteps />
      </DirectSignupProcess>
    </>
  );
};
